<template>
  <div id="app">
    <template v-if="tokenAuth&&currentRouteName=='OneTrack'">
      <nav-one />
    </template>
    <template v-else-if="tokenAuth" >
       <Nav />
    </template>
    
  <!--  <autologout> </autologout>-->
    <div :class="tokenAuth ? 'makeStyles-content-10' : 'height-100'">
      <router-view></router-view>
    </div>

    <loader v-show="isLoading"> </loader>
    <alert-message v-show="showAlert"></alert-message>
  </div>
</template>

<script>
import Nav from "./components/Nav";
import { mapState } from "vuex";
import Loader from "./components/Loader.vue";
import AlertMessage from "./components/AlertMessage.vue";
import NavOne from './components/OneTrack/NavOne.vue';
//import Autologout from "./components/Autologout.vue";
export default {
  name: "App",
  data() {
    return {
      name: "",
    };
  },
  components: {
    Nav,
    Loader,
    AlertMessage,
    NavOne  //Autologout,
  },
  computed: {
    currentRouteName() {
        return this.$route.name;
    },
    ...mapState("module", ["tokenAuth"]),
    ...mapState({
      showAlert: (state) => state.showAlert,
      isLoading: (state) => state.isLoading,
    }),
  },
  mounted() {
    this.checkLocalstore();
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.onStorageUpdate);
  },
  watch: {
    name(newName) {
      console.log(newName);
      localStorage.name = newName;
    },
  },
  methods: {
    checkLocalstore() {
      if (!this.tokenAuth) return;

      const val = this;
      window.addEventListener("storage", function (event) {
        let obj = JSON.parse(event.newValue);
        let auth = obj ? obj.module : false;
        if (event.key === "vuex" && !auth.tokenAuth) {
          val.$router.go("/login");
          console.log("Logged out from another tab!");
        }
      });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");

html,
body {
  height: 100%;
  font-family: "Montserrat", sans-serif;
}

#app {
  height: 100%;
  display: flex;
  background: #f8f8f8;
  font-family: "Montserrat", sans-serif;
}
.makeStyles-content-10 {
  max-width: 100%;
  flex-grow: 1;
  display: block;
  margin-top: 60px;
}
.height-100 {
  height: 100%;
  width: 100%;
}
</style>
